import { render, staticRenderFns } from "./FeedbackTooltip.vue?vue&type=template&id=5935284a&scoped=true"
import script from "./FeedbackTooltip.vue?vue&type=script&lang=js"
export * from "./FeedbackTooltip.vue?vue&type=script&lang=js"
import style0 from "./FeedbackTooltip.vue?vue&type=style&index=0&id=5935284a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935284a",
  null
  
)

export default component.exports